import { TableLayout, TableLayoutProps } from "@portal/components/layout/TableLayout";
import { AdminUserMenu } from "../settings/AdminUserMenu";
import { AdminHeaderActionButtons } from "../shared/AdminHeaderActionButtons";

type AdminTableLayoutProps = Pick<
	TableLayoutProps,
	"title" | "children" | "userMenu" | "scrollable" | "topContent"
>;

export const AdminTableLayout = (props: AdminTableLayoutProps) => (
	<TableLayout
		{...props}
		userMenu={<AdminUserMenu />}
		headerActionButtons={<AdminHeaderActionButtons />}
	/>
);
